import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
        width={27}
        height={27}
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        >
        <path
            d="M19.125 9.66l-2.91-2.91h-3.18l6.09 6.092v8.533h-4.034l-7.216-7.216V6.75h-2.25V22.5a1.125 1.125 0 001.125 1.125h13.5a1.125 1.125 0 001.125-1.125V6.75h-2.25v2.91zm-11.25 7.682l4.034 4.033H7.875v-4.033z"
            fill={theme["#0EA59D"]}
        />
        <path
            d="M25.875 3.375H1.125A1.125 1.125 0 000 4.5v6.75a1.125 1.125 0 001.125 1.125H4.5v-2.25H2.25v-4.5h22.5v4.5H22.5v2.25h3.375A1.125 1.125 0 0027 11.25V4.5a1.125 1.125 0 00-1.125-1.125z"
            fill={theme["#0EA59D"]}
        />
        <path
            d="M16.875 13.5a3.374 3.374 0 10-6.748 0 3.374 3.374 0 006.748 0zm-4.5 0a1.126 1.126 0 112.251 0 1.126 1.126 0 01-2.251 0z"
            fill={theme["#0EA59D"]}
        />
        </svg>
    )
}
  
  export default SvgComponent